import { render, staticRenderFns } from "./AgencyRulesManagement.vue?vue&type=template&id=f404a67e&"
import script from "./AgencyRulesManagement.vue?vue&type=script&lang=js&"
export * from "./AgencyRulesManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports